import { Icon, IconProps, List } from "@amzn/awsui-components-console";
import React from "react";

import { MetricsResponse, ProcessingStepSection } from "@/types/chat-response";

import ProcessingStep from "./ProcessingStepSection";

export interface MetricsSectionProps {
  metrics: MetricsResponse;
}

/** Format tool usage counts as "tool_name (×2), other_tool (×1)" */
const formatToolCounts = (toolCounts: Record<string, number>): string => {
  const entries = Object.entries(toolCounts);
  if (entries.length === 0) return "None";
  return entries.map(([name, count]) => `${name} (×${count})`).join(", ");
};

const MetricsSection: React.FC<MetricsSectionProps> = ({
  metrics: { tokens, inputTokens, outputTokens, time, tools, toolCounts },
}) => (
  <ProcessingStep section={"Execution Summary" as ProcessingStepSection} defaultExpanded>
    <List
      ariaLabel="Execution Summary"
      items={[
        {
          id: "time",
          content: `Execution Time: ${time}`,
          icon: "status-pending",
        },
        {
          id: "tokens",
          content: `Tokens: ${tokens.toLocaleString()} total (${inputTokens.toLocaleString()} in / ${outputTokens.toLocaleString()} out)`,
          icon: "transcript",
        },
        {
          id: "tools",
          content: `Tools: ${
            toolCounts && Object.keys(toolCounts).length > 0
              ? formatToolCounts(toolCounts)
              : tools.length > 0
              ? tools.join(", ")
              : "None"
          }`,
          icon: "script",
        },
      ]}
      renderItem={(item) => ({
        id: item.id,
        content: <div>{item.content}</div>,
        icon: <Icon name={item.icon as IconProps.Name} aria-label="" />,
      })}
    />
  </ProcessingStep>
);

export default MetricsSection;
